var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"announcement-modal-content"},[_vm._t("default"),_vm._v(" "),_c('img',{staticClass:"announcement-modal-content__image",attrs:{"src":_vm.src,"srcset":_vm.srcset}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }